function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("rect", {
  width: 60,
  height: 60,
  fill: "#fff"
}), React.createElement("rect", {
  x: 23,
  y: 46,
  width: 4,
  height: 4,
  fill: "#adafb5"
}), React.createElement("rect", {
  x: 33,
  y: 46,
  width: 4,
  height: 4,
  fill: "#adafb5"
}), React.createElement("path", {
  d: "M43,27.36H42V14H18V46H42V33.63h0a3.21,3.21,0,0,0,3.41-3.14C45.41,28.77,44,27.36,43,27.36Z",
  fill: "#adafb5"
})));

function SvgTerminalbox(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 60 60"
  }, props), _ref);
}

export default __webpack_public_path__ + "static/media/terminalbox.222b80a8.svg";
export { SvgTerminalbox as ReactComponent };